<h1 class="page-title mb-5"> بيانات إحصائية</h1>
<div>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-9">
        <ul>
          <li>التقرير السنوي المالي لسنة 2023- 2024 للإطلاع إضغط <span><a href="../../assets/Year 2024 vs 2023.pdf">هنا
              </a></span></li>
          <li><a href="../../assets/مقارن بيانات و مؤشرات عام 2024 بعام 2023.pdf">مقارن بيانات و مؤشرات عام 2024 بعام
              2023.</a></li>
          <li><a href="../../assets/مقارن بيانات و مؤشرات عام 2024 بعام 2023.pdf">مقارن بيانات و مؤشرات عام 2024 بعام
              2023.</a></li>
          <li><a href="../../assets/GAFI - Indicators Report - Mar 25 - AR.pdf"> بيانات ومؤشرات مارس 2025</a></li>
        </ul>
      </div>
      <div class="col-md-3">
        <app-fix-how-we-can-help></app-fix-how-we-can-help>
      </div>
    </div>
  </div>
</div>